import { URL_LABEL } from "../../../index.content";

const usingAMZScoutIs100PercentSafe = ({ language, isSavedUser }) => {
  return {
    title: "Using AMZScout is 100% safe",
    url: `/safety-using/?${URL_LABEL}`,
    target: false,
    ref: false,
    isLink: true,
  };
};

export default usingAMZScoutIs100PercentSafe;
